import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";
import {ItemShopProduct} from "@/modules/redactor/models/item-shop/ItemShopProduct";

export class ItemShop extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._item = null;
        this._products = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    valid() {

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (!this.item || !this.item.valid() || this.item.any()) {
            return false;
        }

        if (!this.products || this.products.length === 0) {
            return false;
        }

        if (this.products.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.item;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemShop());
        } else if (target instanceof ItemShop) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemShop, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _item: alias("item", ItemKey.schema()),
    _products: alias("products", list(ItemShopProduct.schema()))
});